import React from "react";
import styles from "./style.module.css";
export const NoPage = () => {
  return <div className={styles.container}></div>;
};
